import { render, staticRenderFns } from "./QuestionBankCohortForm.vue?vue&type=template&id=45d43e25&scoped=true&"
import script from "./QuestionBankCohortForm.vue?vue&type=script&lang=js&"
export * from "./QuestionBankCohortForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankCohortForm.vue?vue&type=style&index=0&id=45d43e25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d43e25",
  null
  
)

export default component.exports